export const CAMPAIGN_LOADING = "CAMPAIGN_LOADING";
export const GET_CAMPAIGN = "GET_CAMPAGIN";
export const CAMPAIGN_NOT_FOUND = "CAMPAIGN_NOT_FOUND";
export const SUBMIT_CAMPAIGN_SUCCESS = "SUBMIT_CAMPAIGN_SUCCESS";
export const SUBMIT_CAMPAIGN_FAIL = "SUBMIT_CAMPAIGN_FAIL";
export const REMOVE_CAMPAIGN_DATA = "REMOVE_CAMPAIGN_DATA";
